import React from 'react';

function SplatterFive(props) {
    return(
<svg style={props.stylez} version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="128.000000pt" height="128.000000pt" viewBox="0 0 1280.000000 1280.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.15, written by Peter Selinger 2001-2017
</metadata>
<g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M5860 11625 c-12 -19 -25 -61 -30 -92 -5 -32 -15 -76 -23 -99 -8 -23
-16 -83 -17 -135 -3 -127 -3 -135 5 -176 11 -62 34 -20 44 83 7 73 16 107 55
193 45 101 55 153 37 189 -5 9 -14 29 -20 45 -14 36 -25 34 -51 -8z"/>
<path d="M5534 11575 c-7 -40 10 -115 27 -115 5 0 17 16 26 35 22 46 9 108
-24 113 -18 3 -23 -3 -29 -33z"/>
<path d="M5155 11510 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4997 11044 c-4 -4 -7 -15 -7 -24 0 -9 -11 -27 -25 -40 -14 -13 -32
-47 -41 -75 -16 -49 -16 -53 4 -92 23 -43 79 -89 217 -174 76 -47 83 -50 135
-45 30 2 69 7 86 11 18 4 34 3 36 -2 3 -4 2 -36 -1 -71 -8 -71 3 -113 43 -171
19 -28 26 -50 26 -87 0 -27 4 -75 10 -106 8 -52 23 -251 22 -288 -1 -8 3 -52
9 -97 16 -137 14 -236 -6 -267 -19 -28 -19 -28 -13 -251 3 -77 0 -164 -6 -193
l-10 -52 -59 57 c-71 69 -61 44 17 -46 56 -64 60 -72 56 -123 -2 -30 17 -71
29 -64 9 6 28 -15 49 -53 12 -20 11 -26 -6 -45 -19 -19 -19 -24 -6 -55 15 -35
12 -51 -11 -51 -25 0 -38 -38 -26 -72 6 -17 10 -32 9 -34 -2 -1 -19 3 -39 10
-31 11 -42 10 -73 -3 -23 -10 -36 -22 -36 -35 0 -10 -19 -39 -41 -64 -42 -44
-42 -44 -35 -106 3 -33 9 -74 12 -90 4 -22 2 -27 -10 -23 -8 3 -17 -1 -20 -8
-6 -17 -35 -6 -103 38 -24 15 -51 27 -60 26 -13 0 -11 -3 7 -10 13 -6 40 -22
60 -37 19 -15 38 -27 43 -27 4 0 7 -3 7 -7 0 -5 0 -13 0 -18 0 -6 -13 -4 -30
5 -40 21 -47 19 -19 -5 23 -18 23 -19 4 -21 -38 -3 -70 -6 -109 -10 -31 -3
-40 0 -42 14 -1 9 2 19 7 23 16 9 10 20 -18 33 -26 12 -27 12 -12 -6 9 -10 15
-31 14 -48 -1 -25 -8 -32 -41 -43 -21 -7 -49 -11 -61 -9 -14 3 -23 -1 -23 -8
0 -9 -17 -13 -55 -13 -30 1 -60 -4 -67 -10 -22 -17 -117 -45 -138 -39 -10 3
-21 0 -23 -6 -2 -6 -30 -14 -63 -18 -75 -9 -222 -36 -298 -55 -33 -9 -123 -17
-209 -20 -82 -2 -155 -9 -162 -14 -7 -6 -32 -17 -56 -25 -43 -14 -43 -14 -7
-8 24 3 44 0 58 -10 16 -11 30 -13 53 -6 45 13 172 40 237 49 123 19 417 70
450 80 57 16 162 38 212 45 43 6 46 5 41 -14 -3 -12 -22 -36 -43 -55 -37 -33
-39 -34 -106 -29 l-69 5 30 -21 c17 -12 35 -21 40 -21 6 0 3 5 -5 11 -12 9
-12 10 -1 7 25 -7 24 -27 -3 -40 -20 -9 -37 -9 -74 1 -83 21 -99 21 -34 0 34
-11 62 -25 62 -29 0 -9 -29 -27 -90 -56 -19 -9 -37 -19 -40 -23 -20 -26 -121
-95 -180 -122 -25 -11 -61 -30 -80 -42 -19 -12 -64 -29 -100 -39 -36 -9 -90
-25 -120 -36 -44 -16 -188 -61 -245 -77 -18 -5 -139 -92 -159 -114 -11 -12
-27 -21 -36 -21 -9 0 -20 -4 -26 -10 -9 -9 -41 -27 -144 -80 -25 -13 -52 -27
-60 -32 -8 -4 -24 -12 -35 -17 -73 -32 -328 -163 -361 -185 -21 -14 -43 -26
-48 -26 -5 0 -31 -19 -57 -42 -27 -24 -62 -54 -78 -68 -17 -14 -36 -38 -42
-53 -15 -36 -52 -54 -110 -54 -53 -1 -99 -22 -128 -59 -25 -32 -75 -43 -201
-43 -93 0 -237 29 -251 51 -14 20 -6 41 19 54 44 22 62 45 51 65 -5 11 -20 19
-33 19 -23 0 -56 -28 -56 -47 0 -6 -9 -22 -21 -37 -42 -54 1 -139 78 -157 34
-7 52 -5 93 11 58 23 168 26 313 10 108 -13 138 -2 213 73 29 28 66 64 83 78
23 20 31 35 31 59 0 35 24 62 78 86 17 8 32 18 32 22 0 14 116 91 198 132 165
83 293 140 311 140 11 0 23 4 26 10 7 11 57 36 100 49 70 22 134 50 171 75 22
14 53 26 71 26 18 0 43 10 60 23 15 13 62 31 103 42 41 10 107 35 145 54 39
20 93 47 120 59 52 23 114 57 200 110 28 18 66 39 86 47 20 9 41 27 48 41 6
13 18 27 28 31 9 4 51 31 92 61 87 62 113 74 123 58 5 -7 8 -6 8 4 0 11 2 12
8 3 5 -8 19 -9 44 -4 20 5 39 6 42 4 2 -3 10 -2 17 3 9 5 7 9 -7 15 -12 4 -4
6 23 5 24 0 43 -5 43 -10 0 -4 7 -5 16 -2 10 4 14 1 12 -6 -3 -7 -15 -15 -29
-16 -13 -2 -28 -8 -34 -14 -7 -6 0 -7 20 -3 l30 6 -30 -14 c-16 -8 -48 -18
-70 -22 -22 -5 -42 -9 -45 -10 -3 -1 -23 -7 -45 -13 -22 -7 -53 -12 -70 -12
-16 0 -37 -5 -45 -11 -11 -8 -6 -9 22 -5 21 2 40 1 43 -4 3 -5 13 -7 23 -4 9
4 4 -3 -13 -15 l-30 -21 25 -1 c14 -1 37 0 53 1 32 2 36 -16 6 -25 -11 -4 -18
-13 -16 -20 3 -7 0 -18 -6 -25 -9 -10 -9 -11 2 -5 8 4 28 9 45 11 17 2 41 6
54 9 12 3 22 1 22 -4 0 -22 -24 -61 -42 -66 -10 -4 -18 -11 -18 -17 0 -5 7 -7
16 -4 10 4 14 1 11 -6 -2 -7 -11 -12 -20 -12 -9 1 -14 -3 -11 -8 3 -5 -3 -16
-14 -24 -12 -8 -19 -21 -16 -28 5 -13 -44 -116 -55 -116 -4 0 -18 32 -32 70
-18 46 -23 71 -15 74 6 2 3 5 -6 5 -10 1 -18 5 -18 10 0 5 -12 16 -26 26 -25
16 -28 16 -36 1 -5 -9 -15 -16 -23 -16 -8 0 -17 -5 -21 -11 -4 -7 0 -9 14 -5
29 9 35 -14 33 -129 -1 -88 -4 -104 -26 -137 -14 -21 -29 -37 -33 -37 -20 3
-21 -3 -2 -23 21 -23 27 -44 10 -33 -5 3 -10 -1 -10 -9 0 -8 -21 -31 -46 -51
-50 -37 -52 -49 -3 -15 15 12 42 26 59 31 16 6 28 14 25 19 -7 12 18 28 40 25
80 -9 124 -19 146 -35 15 -11 29 -16 33 -13 13 14 5 58 -16 80 -12 12 -22 31
-23 40 -1 10 -7 31 -14 46 -16 39 -14 45 22 107 22 37 46 62 71 75 22 11 53
32 70 48 17 15 42 27 56 28 14 0 19 3 13 6 -19 7 -16 23 5 23 9 0 30 16 45 35
15 19 37 35 47 35 24 0 26 -15 5 -24 -8 -3 -15 -11 -15 -18 0 -7 -14 -22 -30
-33 -16 -11 -30 -25 -30 -31 0 -7 -10 -14 -23 -18 -13 -3 -50 -23 -82 -45 -32
-22 -63 -37 -68 -34 -6 3 -7 1 -3 -5 4 -6 14 -8 23 -5 12 5 14 3 8 -7 -5 -9
-4 -11 4 -6 6 4 9 11 7 15 -6 9 61 54 83 56 10 1 30 9 45 18 32 21 52 14 34
-12 -16 -22 -115 -108 -162 -141 -19 -14 -36 -29 -36 -34 0 -5 8 -2 18 6 32
30 114 70 128 64 10 -4 25 6 41 24 37 44 67 40 95 -12 12 -24 21 -47 19 -53
-5 -19 41 30 50 53 5 12 13 22 19 22 13 0 5 -153 -10 -180 -7 -13 -3 -23 15
-40 14 -13 27 -31 30 -41 4 -12 26 -24 57 -34 28 -8 58 -21 67 -29 41 -35 122
-22 207 32 61 39 77 70 69 137 -11 81 9 68 25 -17 8 -39 16 -66 18 -60 2 7 -3
42 -11 79 -25 117 -10 242 19 153 7 -21 8 -45 3 -65 -13 -46 -11 -81 7 -96 16
-13 64 -112 64 -133 0 -6 7 -24 16 -41 24 -46 65 -146 76 -185 5 -19 14 -53
19 -74 5 -22 23 -56 39 -77 17 -20 30 -43 30 -50 0 -8 5 -21 11 -29 8 -12 9
-8 6 15 -3 16 1 45 9 63 9 22 10 37 4 45 -52 62 -90 118 -95 140 -4 15 -11 30
-16 32 -4 3 -6 13 -3 23 5 14 4 14 -4 2 -9 -12 -13 -9 -21 13 -17 43 -24 77
-17 77 4 0 11 -10 16 -22 8 -21 9 -21 9 -3 0 11 -6 28 -14 39 -21 27 -5 49 49
65 29 8 46 19 46 29 0 13 -2 13 -18 -1 -10 -10 -26 -17 -36 -17 -17 0 -20 5
-30 53 -5 20 -12 27 -30 27 -24 0 -86 49 -86 69 0 6 14 20 30 33 33 24 37 43
16 73 -28 42 -30 67 -5 86 21 16 23 21 12 48 -6 17 -7 33 -3 36 5 3 7 13 3 23
-7 22 38 -30 82 -95 47 -70 61 -76 28 -12 -15 28 -33 53 -40 56 -27 11 -73 91
-73 127 0 50 14 48 55 -9 15 -20 15 -20 8 0 -7 19 -6 20 20 2 15 -9 27 -13 27
-8 0 5 -15 16 -34 25 -34 16 -51 40 -40 57 16 27 85 -22 118 -85 21 -39 13
-63 -10 -32 -7 11 -16 18 -18 15 -8 -8 65 -89 80 -89 21 0 17 18 -6 30 -22 12
-27 40 -7 40 6 0 28 -17 48 -38 19 -21 41 -36 47 -34 16 5 15 22 0 22 -16 0
-88 75 -88 91 0 7 -16 32 -36 56 -28 34 -34 47 -24 53 7 5 20 6 28 2 11 -4 13
-1 7 8 -5 9 -4 11 4 6 6 -4 9 -11 6 -16 -3 -4 2 -10 10 -14 8 -3 15 -14 15
-25 0 -13 5 -18 13 -15 7 2 21 -4 31 -15 10 -11 24 -17 32 -14 11 4 7 11 -16
24 -38 24 -67 84 -50 105 10 11 16 11 36 -3 13 -8 27 -26 30 -39 3 -13 12 -24
19 -24 15 0 125 -116 125 -132 0 -6 3 -8 6 -5 4 4 -4 21 -18 39 -13 18 -36 54
-51 81 -16 26 -33 47 -39 47 -6 0 -9 3 -5 6 13 13 99 -40 122 -75 32 -50 62
-81 92 -92 32 -12 41 -6 49 37 l7 36 73 -5 c40 -3 81 -10 92 -16 11 -6 42 -12
68 -15 64 -6 175 -25 187 -33 47 -29 117 -13 117 27 0 28 -15 32 -36 9 -15
-16 -26 -19 -59 -14 -86 13 -141 28 -160 45 -30 26 -61 40 -90 40 -21 0 -49
23 -125 100 -90 92 -120 115 -120 91 0 -15 122 -136 135 -134 6 2 27 -13 45
-32 44 -45 31 -56 -60 -53 -59 3 -65 5 -68 26 -4 24 16 30 36 10 6 -6 14 -9
18 -5 3 3 -20 19 -52 35 -33 17 -64 39 -71 50 -7 11 -37 37 -67 57 -31 20 -54
40 -53 43 4 12 -7 14 -35 7 -17 -5 -35 -1 -53 11 -25 16 -26 19 -9 25 16 6 17
8 4 13 -20 8 -26 76 -8 76 10 0 10 2 1 8 -17 10 101 141 125 137 9 -1 11 0 4
2 -8 3 -11 11 -6 21 3 10 9 28 12 42 7 36 40 80 68 90 12 5 28 18 33 29 9 16
6 23 -16 41 -27 21 -27 22 -10 51 16 29 16 30 -1 25 -29 -9 -53 50 -41 100 4
22 9 62 9 89 0 31 7 62 19 82 11 17 25 59 32 92 13 66 16 71 63 80 23 5 36 16
48 42 35 71 82 309 61 309 -6 0 -13 -35 -16 -77 -9 -112 -38 -187 -89 -235
l-43 -39 -8 33 c-4 18 -8 47 -8 63 -1 54 -21 -1 -27 -72 -2 -35 -9 -66 -14
-69 -21 -13 -75 62 -97 136 -13 41 -29 83 -37 94 -8 11 -14 31 -14 43 0 36 69
99 153 139 91 43 142 92 207 201 31 50 54 78 66 78 9 0 19 6 22 13 2 7 -2 10
-12 6 -9 -3 -16 -1 -16 5 0 6 5 11 10 11 6 0 10 7 10 15 0 13 -4 12 -22 -5
-33 -30 -34 -15 -2 24 34 41 40 43 47 16 4 -17 12 -20 41 -18 41 2 42 4 20 25
-15 15 -14 17 3 27 22 14 28 36 9 36 -8 0 -17 3 -20 8 -2 4 20 7 49 7 48 -1
54 1 60 22 3 14 13 23 25 23 22 0 27 16 8 23 -10 4 -10 6 0 6 17 1 15 21 -3
21 -8 0 -15 -4 -15 -10 0 -5 -11 -10 -25 -10 -14 0 -24 -5 -23 -11 2 -6 -3
-14 -9 -16 -21 -8 -15 21 12 57 20 27 25 46 25 91 0 32 -4 60 -8 63 -5 3 -26
-12 -46 -33 -36 -37 -38 -42 -36 -98 4 -79 2 -103 -10 -103 -5 0 -15 12 -23
26 -13 24 -15 25 -30 9 -16 -16 -37 -13 -37 5 0 5 6 15 14 22 7 8 17 25 21 38
4 13 14 31 22 38 11 11 12 17 2 22 -6 4 -8 13 -5 19 4 6 2 11 -5 11 -8 0 -8 4
1 15 10 12 15 13 21 3 5 -8 10 -3 14 15 4 15 11 24 16 21 5 -3 8 8 7 23 -2 40
-8 47 -23 26 -11 -15 -15 -16 -31 -3 -11 9 -15 10 -10 3 4 -8 1 -13 -8 -13 -9
0 -16 -7 -16 -15 0 -17 -25 -20 -35 -5 -11 18 -27 11 -22 -10 7 -26 -7 -34
-26 -15 -9 8 -26 16 -39 17 -18 2 -23 -2 -22 -19 0 -14 -5 -23 -14 -23 -10 0
-12 7 -8 25 6 23 4 24 -26 18 -18 -3 -36 -11 -39 -16 -16 -24 -29 7 -24 61 5
59 1 55 -10 -11 -4 -22 -13 -41 -23 -44 -9 -4 -25 -15 -34 -26 -10 -11 -18
-15 -18 -9 0 7 -7 12 -15 12 -25 0 -95 -39 -95 -53 0 -20 22 -37 48 -37 13 0
20 -4 17 -10 -4 -6 7 -10 24 -10 33 0 43 -22 17 -37 -7 -4 -19 -19 -26 -32
-11 -22 -10 -23 6 -19 11 3 27 9 37 13 14 6 17 2 17 -21 0 -16 -4 -45 -10 -64
-9 -32 -8 -34 6 -15 8 11 18 31 21 43 5 21 47 72 58 72 11 0 -2 -40 -18 -58
-9 -10 -17 -31 -17 -45 0 -16 -10 -36 -24 -48 -14 -12 -22 -27 -20 -33 6 -16
-33 -65 -60 -76 -12 -4 -23 -18 -24 -31 -5 -41 -8 -53 -20 -83 -16 -37 -12
-40 29 -22 19 8 56 20 82 27 40 10 47 15 45 33 -3 17 3 22 32 24 31 3 70 22
44 22 -5 0 -10 8 -10 18 0 10 8 18 17 18 10 0 16 -3 14 -6 -2 -3 0 -12 6 -20
7 -12 9 -12 9 3 0 10 7 20 15 23 8 4 15 16 15 27 0 20 0 20 14 1 10 -13 11
-23 4 -31 -6 -7 -8 -23 -4 -36 11 -44 -83 -159 -158 -194 -57 -26 -105 -58
-150 -101 l-45 -43 4 38 c6 48 -10 330 -21 363 -4 14 -8 102 -8 197 l-1 172
-57 51 c-51 46 -59 57 -83 135 -14 47 -28 113 -29 148 -6 113 -18 212 -27 221
-22 23 -8 68 36 123 25 31 43 58 39 62 -4 3 -9 0 -11 -6 -3 -7 -22 -34 -44
-60 l-40 -48 6 -160 c5 -127 12 -177 31 -241 39 -133 33 -148 -56 -142 -57 3
-74 -19 -65 -85 11 -89 -32 -103 -91 -29 -21 26 -47 56 -57 67 -21 23 -81 144
-108 220 -11 31 -18 78 -19 123 0 40 -5 82 -10 92 -6 11 -42 47 -81 80 l-70
61 -105 -4 c-110 -3 -161 9 -207 51 -11 9 -38 26 -61 37 -40 20 -41 21 -46 80
-3 34 -13 73 -23 89 -18 26 -18 28 4 72 13 29 18 49 12 55 -5 5 -12 6 -16 3z
m584 -721 c6 -16 13 -46 16 -68 8 -74 13 -85 71 -148 31 -35 74 -89 95 -119
42 -62 97 -206 97 -258 0 -34 13 -84 71 -270 30 -98 54 -274 53 -385 0 -46 -6
-71 -27 -108 -32 -56 -32 -57 -11 -57 9 0 14 -7 12 -17 -4 -24 -28 -28 -34 -7
-6 23 -66 64 -93 64 -20 0 -51 -39 -51 -64 0 -17 -30 -30 -31 -13 -1 7 -2 17
-4 22 -1 6 -3 18 -3 28 -1 9 -8 17 -16 17 -9 0 -26 33 -45 83 -16 45 -30 76
-30 68 -1 -16 53 -180 75 -228 8 -17 14 -42 15 -55 0 -21 1 -22 8 -3 8 19 9
18 21 -7 15 -32 6 -72 -11 -48 -8 11 -9 6 -5 -20 l6 -35 -20 24 c-11 13 -20
33 -20 45 0 17 -2 18 -10 6 -8 -12 -10 -12 -16 3 -3 10 -16 23 -28 29 l-21 11
20 -24 c49 -56 50 -60 17 -43 -39 19 -51 52 -27 71 17 11 17 17 5 53 -11 34
-22 45 -59 63 -42 20 -46 26 -49 60 -2 25 2 45 12 56 14 16 14 24 -5 92 -22
78 -34 215 -19 224 5 3 14 -13 21 -35 17 -55 23 -44 7 13 -10 40 -9 51 7 87
16 35 17 45 6 62 -18 28 -40 159 -51 293 -5 61 -16 177 -25 258 -23 221 -24
276 0 293 32 23 64 18 76 -13z m294 -383 c8 -14 -4 -90 -15 -90 -7 0 -40 76
-40 93 0 11 48 8 55 -3z m770 -119 c-3 -6 -11 -11 -17 -11 -6 0 -6 6 2 15 14
17 26 13 15 -4z m95 -17 c0 -2 -9 -4 -21 -4 -11 0 -18 4 -14 10 5 8 35 3 35
-6z m-106 -29 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7
4 -15z m76 0 c12 -15 6 -35 -12 -35 -5 0 -8 6 -5 14 3 7 0 19 -6 25 -8 8 -8
11 0 11 6 0 16 -7 23 -15z m-130 -146 c-7 -11 -14 -19 -16 -16 -7 7 7 37 17
37 6 0 5 -9 -1 -21z m-1025 -512 c5 -25 2 -49 -8 -70 -8 -18 -17 -39 -21 -47
-3 -8 -3 5 0 30 3 25 6 70 5 100 -2 61 13 54 24 -13z m575 -77 c0 -5 -4 -10
-10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m10 -30 c0 -5 -4
-10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m48 -53 c-2
-17 -8 -32 -14 -34 -15 -5 -23 27 -17 61 4 22 8 24 20 15 8 -7 13 -25 11 -42z
m-562 -125 c-3 -3 -12 1 -20 7 -10 8 -16 9 -21 1 -10 -17 -25 -12 -34 13 -13
34 8 39 46 10 18 -14 31 -28 29 -31z m-7 -11 c8 -6 11 -16 6 -31 -5 -15 -4
-20 4 -16 6 4 11 2 11 -3 0 -24 -43 1 -53 31 -9 26 6 35 32 19z m-34 -232 c20
-37 14 -46 -20 -31 -17 8 -25 20 -25 37 0 35 26 32 45 -6z m-511 -599 c15 -15
5 -19 -66 -23 l-67 -3 32 23 c32 25 78 26 101 3z m-149 -40 c-3 -5 -12 -10
-18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z m1283 -7 c6 -19 -25 -16 -32 3 -4
11 -1 14 11 12 9 -2 18 -9 21 -15z m-1198 -113 c0 -5 -10 -10 -21 -10 -12 0
-27 -7 -33 -15 -7 -10 -33 -18 -71 -21 -49 -4 -55 -2 -35 6 19 9 21 13 11 20
-10 6 -7 8 10 9 13 0 44 4 69 9 63 13 70 13 70 2z m98 -150 c-7 -11 -18 -20
-24 -20 -7 0 -22 -11 -35 -25 -13 -13 -30 -25 -38 -25 -19 0 23 46 64 71 39
24 48 24 33 -1z m172 -95 c10 -12 10 -18 0 -30 -7 -9 -14 -26 -15 -39 -2 -13
-6 -34 -10 -46 -11 -34 -32 -7 -29 40 1 28 -2 40 -12 40 -8 0 -14 5 -14 10 0
6 9 10 20 10 11 0 23 7 26 15 4 8 10 15 14 15 4 0 13 -7 20 -15z m-100 -35 c0
-6 -12 -15 -26 -20 -37 -14 -40 -12 -18 9 21 22 44 27 44 11z m520 -50 c0 -5
7 -10 15 -10 9 0 15 -10 15 -26 0 -16 -4 -23 -11 -18 -8 5 -10 0 -6 -17 10
-39 -7 -55 -26 -25 -17 26 -22 62 -11 90 7 18 24 22 24 6z m181 -253 c6 -10 6
-24 1 -33 -7 -13 -10 -13 -15 -3 -3 8 -13 32 -22 54 l-17 40 22 -20 c12 -11
26 -28 31 -38z"/>
<path d="M5577 10004 c-15 -15 -7 -45 11 -42 9 2 17 12 17 22 0 20 -16 31 -28
20z"/>
<path d="M5596 9235 c21 -67 38 -108 41 -99 2 6 -8 36 -22 65 -14 30 -23 45
-19 34z"/>
<path d="M5570 9189 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5910 10920 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M4382 10903 c5 -25 28 -28 28 -4 0 12 -6 21 -16 21 -9 0 -14 -7 -12
-17z"/>
<path d="M4427 10743 c-13 -12 -7 -33 8 -33 8 0 15 9 15 20 0 20 -11 26 -23
13z"/>
<path d="M7590 10649 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M6373 10585 c-47 -33 -31 -141 24 -161 25 -8 27 -13 26 -64 l-1 -55
7 55 c4 30 14 73 21 95 16 49 14 92 -6 122 -17 27 -41 29 -71 8z"/>
<path d="M6413 10260 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M5010 10231 c0 -11 4 -22 9 -25 4 -3 6 6 3 19 -5 30 -12 33 -12 6z"/>
<path d="M5021 10175 c-1 -5 3 -26 9 -45 5 -19 12 -55 15 -80 2 -25 9 -70 15
-100 25 -137 34 -251 22 -284 -16 -45 -15 -60 7 -80 10 -9 32 -46 47 -81 16
-36 33 -65 38 -65 4 0 5 8 1 18 -5 9 -13 37 -20 61 -11 42 -10 57 11 151 7 32
6 34 -10 21 -29 -24 -37 0 -48 130 -6 78 -18 150 -34 198 -13 42 -24 83 -24
91 -1 18 -28 79 -29 65z"/>
<path d="M6790 10150 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6565 10140 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M6850 10125 c0 -8 14 -22 31 -31 l32 -16 -22 31 c-24 33 -41 40 -41
16z"/>
<path d="M6907 10063 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M4710 10002 c0 -5 9 -17 20 -27 22 -20 26 -14 10 16 -11 19 -30 26
-30 11z"/>
<path d="M6210 9920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6320 9860 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6840 9851 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M4795 9815 c4 -11 10 -35 13 -53 2 -18 13 -37 23 -43 31 -16 24 25
-12 74 -18 23 -28 33 -24 22z"/>
<path d="M6845 9810 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6316 9741 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M6720 9710 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6218 9695 c-8 -9 3 -45 13 -45 5 0 9 7 9 15 0 8 0 18 1 22 1 10 -16
15 -23 8z"/>
<path d="M6680 9671 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M6410 9579 c0 -5 11 -9 25 -9 14 0 25 2 25 4 0 2 -11 6 -25 8 -14 3
-25 1 -25 -3z"/>
<path d="M6383 9256 c1 -35 4 -62 7 -59 8 8 7 123 -1 123 -4 0 -7 -29 -6 -64z"/>
<path d="M5310 9196 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M4955 9170 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M5111 9177 c-1 -4 10 -25 24 -47 28 -44 79 -81 140 -101 22 -8 45
-21 52 -29 6 -8 14 -13 17 -10 3 3 -15 28 -40 55 -25 28 -52 60 -61 73 -8 12
-20 22 -25 22 -6 0 4 -16 21 -36 40 -45 32 -60 -18 -34 -36 18 -69 51 -98 96
-6 11 -12 16 -12 11z"/>
<path d="M6391 9164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6478 9145 c2 -14 6 -25 8 -25 2 0 4 11 4 25 0 14 -4 25 -9 25 -4 0
-6 -11 -3 -25z"/>
<path d="M2185 8916 c17 -9 38 -15 47 -16 9 0 20 -5 23 -10 4 -7 11 -7 18 -2
7 5 41 12 77 16 36 3 79 11 95 16 24 7 17 8 -30 4 -95 -8 -187 -9 -225 -1
l-35 7 30 -14z"/>
<path d="M2670 8891 c0 -5 19 -15 43 -22 23 -6 47 -14 52 -19 6 -4 29 -10 52
-14 23 -3 50 -9 60 -12 10 -3 -2 7 -27 24 -25 16 -61 32 -80 36 -84 17 -100
18 -100 7z"/>
<path d="M6779 8700 c24 -5 50 -15 57 -21 8 -7 17 -9 21 -5 14 13 -15 27 -68
31 l-54 4 44 -9z"/>
<path d="M6677 8663 c-23 -21 -51 -43 -61 -49 -11 -6 -22 -16 -24 -23 -5 -16
77 40 112 78 41 43 24 39 -27 -6z"/>
<path d="M4215 8416 c33 -13 80 -26 105 -29 55 -7 48 -4 -63 28 -107 31 -121
31 -42 1z"/>
<path d="M4745 8430 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M4823 8379 c-6 -6 -9 -18 -6 -25 6 -17 -8 -17 -62 -3 -22 6 -62 11
-90 13 -27 2 -95 6 -150 11 -55 4 -98 5 -95 3 3 -3 37 -8 75 -12 39 -3 102
-10 140 -16 39 -5 96 -12 128 -15 44 -5 60 -11 68 -27 6 -11 14 -16 18 -11 4
6 19 6 39 1 25 -7 32 -13 28 -25 -5 -13 -1 -14 23 -10 38 8 149 -29 153 -50 3
-15 4 -15 16 0 11 13 6 18 -45 37 -89 33 -153 71 -180 107 -27 35 -42 40 -60
22z m44 -31 c24 -23 30 -38 13 -38 -13 0 -50 37 -50 50 0 16 12 12 37 -12z"/>
<path d="M4388 8373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4230 8340 c0 -16 37 -30 77 -29 l38 1 -40 9 c-22 5 -44 14 -49 19
-13 13 -26 13 -26 0z"/>
<path d="M6625 8320 c-65 -27 -180 -51 -234 -49 -34 1 -64 -1 -68 -4 -16 -16
149 -6 209 13 34 11 70 20 79 20 9 0 22 7 29 15 14 17 13 17 -15 5z"/>
<path d="M4405 8295 c33 -8 82 -19 108 -26 27 -6 51 -9 54 -6 3 4 -8 9 -23 12
-16 4 -50 13 -76 21 -26 8 -64 14 -85 13 -35 -1 -33 -2 22 -14z"/>
<path d="M4598 8253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4849 8234 c-10 -12 -25 -15 -56 -11 -24 2 -43 1 -43 -3 0 -8 49 -15
137 -22 22 -2 39 0 36 5 -2 4 -18 7 -34 7 -26 0 -29 3 -24 20 8 24 2 26 -16 4z"/>
<path d="M3333 8208 c-48 -23 -8 -65 51 -54 17 4 49 10 70 14 45 8 58 27 24
35 -54 14 -124 16 -145 5z"/>
<path d="M3965 8210 l-90 -6 73 -2 c40 -1 82 -7 93 -13 21 -11 165 -21 154
-11 -7 7 -89 31 -120 36 -11 2 -60 0 -110 -4z"/>
<path d="M3638 8173 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3405 8130 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 -11
0 -17 -4 -14 -10z"/>
<path d="M4420 8131 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0
-20 -4 -20 -9z"/>
<path d="M4875 8120 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3875 8101 c-7 -12 18 -18 103 -24 34 -3 74 -13 88 -22 19 -12 39
-15 77 -11 29 3 71 5 95 6 58 0 53 16 -7 19 -27 1 -93 6 -147 12 -55 6 -113
12 -130 14 -17 1 -41 6 -52 9 -11 4 -23 2 -27 -3z"/>
<path d="M6320 8036 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M3275 7860 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M3641 7859 c-24 -5 -46 -11 -49 -14 -10 -10 43 -4 83 10 46 15 30 17
-34 4z"/>
<path d="M3476 7824 c-38 -8 -71 -16 -74 -19 -8 -8 86 7 138 21 60 16 23 15
-64 -2z"/>
<path d="M2983 7823 c-18 -2 -33 -9 -33 -14 0 -11 80 -1 95 12 9 9 -1 9 -62 2z"/>
<path d="M4395 7799 c-92 -18 -122 -26 -140 -37 -30 -17 -4 -14 67 8 81 25 96
25 109 -2 l10 -23 -5 23 c-3 18 0 22 21 22 13 0 21 4 18 10 -7 11 -22 11 -80
-1z"/>
<path d="M4685 7800 c3 -5 12 -7 20 -3 21 7 19 13 -6 13 -11 0 -18 -4 -14 -10z"/>
<path d="M4687 7771 c-10 -12 -7 -13 20 -8 19 4 35 2 39 -4 7 -13 -24 -38 -48
-39 -10 0 -18 -4 -18 -10 0 -13 27 -13 36 1 3 6 18 8 33 5 19 -5 22 -4 11 3
-12 9 -12 11 3 17 22 8 29 2 21 -19 -3 -8 -22 -20 -42 -26 -37 -10 -37 -10 8
-4 25 3 53 11 63 18 16 11 16 13 -2 33 -10 12 -24 22 -30 22 -7 0 -10 4 -7 9
10 16 -74 18 -87 2z"/>
<path d="M4636 7746 c3 -8 13 -17 22 -21 13 -5 13 -2 -3 15 -21 24 -26 25 -19
6z"/>
<path d="M5880 7741 c0 -10 27 -41 36 -41 7 0 -15 38 -26 45 -6 3 -10 2 -10
-4z"/>
<path d="M3187 7733 c-14 -13 -6 -22 26 -29 40 -9 150 -6 180 5 44 18 -10 24
-95 11 -72 -10 -83 -10 -94 4 -6 9 -14 13 -17 9z"/>
<path d="M5930 7716 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M3840 7695 c-14 -8 -33 -14 -43 -15 -9 0 -26 -5 -36 -12 -14 -9 -32
-8 -80 4 -33 8 -61 11 -61 7 0 -4 17 -10 38 -15 46 -9 41 -8 75 -17 21 -6 41
-2 70 12 23 10 57 22 76 26 24 5 30 10 20 16 -19 12 -30 11 -59 -6z"/>
<path d="M4915 7680 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M4655 7670 c-59 -16 -98 -35 -132 -66 -19 -18 -60 -40 -91 -50 -31
-10 -50 -20 -41 -22 9 -1 36 4 60 13 24 9 78 28 119 42 41 15 69 28 61 31 -8
3 4 16 31 33 45 30 44 32 -7 19z"/>
<path d="M4788 7673 c-10 -2 -18 -12 -18 -20 0 -14 3 -14 20 2 17 15 26 28 18
24 -2 -1 -11 -3 -20 -6z"/>
<path d="M4850 7660 c-13 -8 -13 -11 -1 -22 10 -10 12 -10 7 0 -4 7 -1 12 8
12 8 0 18 5 21 10 8 13 -15 13 -35 0z"/>
<path d="M4493 7639 c14 -8 22 -8 30 0 8 8 3 11 -18 11 -26 -1 -28 -2 -12 -11z"/>
<path d="M4789 7633 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M7437 7620 c-3 -11 -2 -20 3 -20 12 0 21 28 11 35 -5 2 -11 -4 -14
-15z"/>
<path d="M7170 7601 c-62 -23 -75 -33 -78 -52 -4 -32 58 -146 112 -206 24 -26
50 -62 59 -80 9 -17 53 -68 98 -112 45 -45 74 -71 65 -59 -28 41 -95 155 -105
181 -9 22 -3 36 35 94 25 37 47 78 51 91 10 41 -25 105 -77 142 -44 31 -79 31
-160 1z"/>
<path d="M4835 7610 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6165 7590 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M4380 7579 c-26 -11 -33 -17 -18 -14 36 7 78 23 78 30 0 8 -11 5 -60
-16z"/>
<path d="M6040 7590 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5890 7544 c0 -2 23 -14 51 -28 33 -15 46 -19 36 -9 -14 15 -87 45
-87 37z"/>
<path d="M4205 7519 c-20 -7 -20 -8 -1 -8 18 -1 18 -3 -5 -28 l-24 -28 26 23
c18 15 49 26 95 34 38 5 70 11 72 12 6 7 -147 2 -163 -5z"/>
<path d="M6055 7500 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M5102 7449 c-7 -11 -19 -18 -27 -16 -7 3 -23 -5 -36 -19 -26 -28 -23
-30 17 -9 32 16 84 65 68 65 -5 0 -15 -9 -22 -21z"/>
<path d="M6270 7461 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M3650 7450 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M4134 7438 c-46 -34 -52 -42 -16 -22 31 18 61 44 50 44 -3 0 -18 -10
-34 -22z"/>
<path d="M6458 7452 c-28 -3 -41 -32 -15 -32 7 0 29 -11 47 -25 19 -14 52 -31
72 -37 26 -7 62 -36 115 -90 42 -44 97 -94 122 -111 60 -41 118 -102 142 -152
18 -38 129 -185 129 -171 0 4 -18 31 -40 61 -57 77 -77 122 -62 137 19 19 85
-22 216 -134 21 -18 47 -38 57 -43 45 -25 189 -170 203 -205 10 -25 30 -47 64
-69 27 -17 52 -31 55 -31 4 0 31 -11 61 -25 30 -14 71 -25 90 -25 29 0 38 5
51 30 33 64 15 124 -52 166 -37 23 -113 117 -113 139 0 6 -70 106 -84 120 -5
6 -3 -1 6 -15 76 -123 98 -162 98 -170 0 -15 -80 -34 -141 -34 -51 0 -61 3
-103 39 -26 22 -69 56 -95 75 -27 19 -86 69 -131 110 -45 41 -92 82 -105 90
-13 8 -67 61 -121 117 -73 75 -118 112 -169 139 -38 21 -104 61 -146 89 -77
53 -103 63 -151 57z"/>
<path d="M3905 7400 c-23 -25 -18 -25 36 0 43 19 43 20 13 20 -18 0 -38 -8
-49 -20z"/>
<path d="M4148 7406 c-10 -7 -18 -17 -18 -21 0 -4 6 -2 14 4 8 7 16 8 18 4 3
-4 3 -3 2 4 -2 6 2 14 9 17 7 2 8 5 2 5 -5 0 -18 -6 -27 -13z"/>
<path d="M3430 7392 c0 -5 14 -7 30 -4 17 2 30 6 30 8 0 2 -13 4 -30 4 -16 0
-30 -4 -30 -8z"/>
<path d="M4033 7393 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4041 7359 c-18 -6 -31 -12 -29 -14 5 -5 78 14 78 20 0 6 -8 5 -49
-6z"/>
<path d="M4183 7350 c-30 -12 -29 -30 1 -30 25 0 51 22 39 33 -8 9 -12 8 -40
-3z"/>
<path d="M6125 7330 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M3185 7320 c-8 -13 15 -13 35 0 12 8 11 10 -7 10 -12 0 -25 -4 -28
-10z"/>
<path d="M3753 7295 c-18 -8 -33 -16 -33 -19 0 -5 60 11 68 19 13 12 -5 12
-35 0z"/>
<path d="M6373 7260 c3 -23 12 -47 20 -53 8 -7 33 -40 56 -74 23 -35 44 -63
48 -63 3 0 -2 10 -11 23 -38 53 -70 125 -71 162 -1 34 -5 41 -24 43 -23 4 -24
1 -18 -38z"/>
<path d="M5230 7270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3572 7233 c-18 -8 -31 -18 -28 -20 5 -5 66 25 66 32 0 7 -1 7 -38
-12z"/>
<path d="M3948 7216 c-80 -45 -86 -55 -11 -17 34 17 64 35 68 41 9 14 7 13
-57 -24z"/>
<path d="M6450 7240 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6610 7240 c0 -5 11 -17 24 -26 14 -8 34 -31 45 -50 19 -31 51 -47
51 -25 0 30 -24 63 -63 85 -48 28 -57 31 -57 16z"/>
<path d="M5760 7213 c0 -10 -3 -27 -6 -38 -3 -12 2 -29 13 -42 10 -12 23 -30
30 -40 10 -15 11 -11 7 22 -7 54 -25 115 -36 115 -4 0 -8 -8 -8 -17z"/>
<path d="M5210 7191 c0 -6 -6 -8 -13 -5 -13 5 -40 -50 -29 -60 14 -14 32 -4
32 18 0 27 25 54 33 36 3 -6 4 -5 3 2 -3 15 -26 23 -26 9z"/>
<path d="M4350 7175 c-6 -8 -9 -19 -5 -25 9 -14 45 6 45 25 0 19 -24 19 -40 0z"/>
<path d="M3836 7155 c-11 -8 -16 -15 -10 -15 5 0 18 7 28 15 11 8 16 15 10 15
-5 0 -18 -7 -28 -15z"/>
<path d="M4368 7126 c-50 -28 -49 -39 2 -14 22 11 40 24 40 29 0 5 -1 9 -2 8
-2 -1 -20 -11 -40 -23z"/>
<path d="M5225 7110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3625 7080 c-3 -5 1 -10 9 -10 8 0 18 5 21 10 3 6 -1 10 -9 10 -8 0
-18 -4 -21 -10z"/>
<path d="M3994 7060 c-23 -10 -45 -23 -48 -29 -4 -5 -50 -31 -103 -58 -56 -27
-115 -66 -139 -90 -24 -23 -62 -52 -85 -63 -22 -12 -39 -23 -36 -26 2 -2 41
14 86 37 45 23 84 39 88 36 3 -3 -6 -20 -21 -37 -19 -23 -24 -38 -20 -55 8
-31 -13 -59 -108 -152 -116 -114 -233 -198 -286 -206 -12 -2 -32 -13 -44 -24
-13 -12 -52 -35 -88 -52 -67 -32 -60 -32 20 -1 25 10 65 26 90 36 25 10 63 32
85 49 22 16 53 37 68 45 66 33 314 289 289 298 -37 12 9 73 85 111 23 11 60
42 82 69 22 26 61 60 85 76 25 15 47 34 50 42 7 18 1 17 -50 -6z"/>
<path d="M5785 7049 c-10 -15 3 -25 16 -12 7 7 7 13 1 17 -6 3 -14 1 -17 -5z"/>
<path d="M6071 7043 c0 -12 -4 -30 -7 -40 -5 -17 -5 -17 6 0 6 10 9 28 7 40
-4 22 -4 22 -6 0z"/>
<path d="M7465 7023 c15 -24 30 -43 32 -43 7 0 -31 61 -46 73 -8 7 -2 -7 14
-30z"/>
<path d="M6525 7025 c24 -40 157 -215 163 -215 2 0 0 6 -5 13 -6 6 -43 57 -83
112 -78 107 -105 139 -75 90z"/>
<path d="M2380 6990 c-13 -9 -13 -10 0 -10 8 0 22 5 30 10 13 9 13 10 0 10 -8
0 -22 -5 -30 -10z"/>
<path d="M5703 6915 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M4435 6941 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"/>
<path d="M3643 6893 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M4268 6849 c-34 -32 -25 -29 26 9 16 12 24 22 18 22 -7 0 -26 -14
-44 -31z"/>
<path d="M5080 6870 c0 -7 11 -25 25 -42 17 -20 25 -25 25 -13 0 8 -7 18 -15
21 -8 4 -15 12 -15 19 0 8 -4 17 -10 20 -5 3 -10 1 -10 -5z"/>
<path d="M2000 6850 c-24 -15 -7 -19 20 -5 15 8 19 14 10 14 -8 1 -22 -3 -30
-9z"/>
<path d="M2317 6853 c-12 -11 -8 -40 6 -52 10 -8 18 -7 32 2 14 11 16 17 6 35
-12 22 -31 28 -44 15z"/>
<path d="M4239 6763 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M3917 6693 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6200 6673 c-13 -15 -12 -16 4 -10 10 4 20 7 22 7 2 0 4 5 4 10 0 15
-13 12 -30 -7z"/>
<path d="M7250 6640 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5009 6553 c-18 -27 -26 -42 -16 -35 16 14 60 82 52 82 -2 0 -19 -21
-36 -47z"/>
<path d="M2363 6569 c-6 -6 -19 -12 -29 -13 -16 -2 -24 -17 -9 -16 12 1 75 31
75 35 0 9 -26 5 -37 -6z"/>
<path d="M6880 6482 c0 -6 14 -41 32 -76 29 -60 35 -66 86 -86 30 -11 57 -19
59 -16 2 2 -19 12 -47 22 -52 19 -71 40 -100 114 -15 40 -30 60 -30 42z"/>
<path d="M7580 6470 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5492 6440 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M4179 6423 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M6720 6380 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7980 6330 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2800 6300 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3427 6283 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"/>
<path d="M7111 6264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3381 6247 c-8 -10 -7 -14 2 -14 8 0 14 6 14 14 0 7 -1 13 -2 13 -2
0 -8 -6 -14 -13z"/>
<path d="M3348 6213 c-9 -2 -19 -11 -22 -19 -4 -11 -1 -11 19 2 14 9 25 18 25
20 0 2 -1 3 -2 3 -2 -1 -10 -3 -20 -6z"/>
<path d="M5492 6155 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M2510 6110 c-8 -5 -11 -12 -7 -16 4 -4 15 0 24 9 18 18 8 23 -17 7z"/>
<path d="M5592 6020 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M7532 5994 c10 -10 20 -15 24 -12 3 4 -5 12 -18 18 -22 12 -22 12 -6
-6z"/>
<path d="M5036 5913 c-8 -29 -63 -274 -71 -318 -4 -22 -16 -55 -27 -73 -30
-49 -27 -106 7 -142 27 -28 27 -32 22 -102 -3 -40 -10 -109 -16 -153 -5 -44
-14 -145 -21 -225 -19 -243 -51 -495 -72 -580 -6 -25 -22 -67 -35 -95 -45 -98
-18 -255 44 -255 21 0 83 61 104 101 21 43 26 149 9 194 -8 22 -13 25 -25 15
-7 -6 -24 -10 -37 -8 -21 3 -23 9 -26 62 -3 51 6 146 23 251 2 17 11 95 20
175 9 80 17 159 20 175 2 17 7 64 10 105 11 125 12 132 40 269 19 95 25 148
21 185 -18 142 -17 167 3 273 31 159 31 163 21 163 -5 0 -11 -8 -14 -17z"/>
<path d="M5572 5857 c-28 -30 -28 -58 1 -85 18 -17 26 -19 35 -10 19 19 12
118 -7 118 -4 0 -17 -10 -29 -23z"/>
<path d="M8665 5650 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5047 5303 c-34 -18 -30 -27 7 -17 14 3 26 12 26 20 0 8 -1 14 -2 13
-2 -1 -16 -8 -31 -16z"/>
<path d="M8107 5143 c-4 -3 -7 -17 -7 -30 0 -27 -26 -31 -68 -9 -93 47 -96 17
-8 -68 61 -58 64 -64 75 -126 15 -91 8 -143 -22 -189 -16 -24 -35 -77 -46
-130 -11 -50 -24 -98 -29 -108 -5 -10 -12 -43 -16 -75 -3 -31 -9 -63 -12 -72
-3 -9 -1 -16 5 -16 6 0 11 7 11 16 0 9 20 62 44 118 55 128 53 122 76 229 11
50 20 124 20 163 0 40 5 76 10 79 6 4 22 24 36 46 38 60 68 55 144 -24 33 -35
76 -90 96 -123 44 -74 89 -121 129 -135 51 -19 111 -110 179 -274 l25 -60 1
67 c0 73 5 63 -125 273 -11 17 -30 52 -45 80 -17 34 -44 64 -85 95 -33 25
-103 87 -155 137 -53 51 -111 104 -130 118 -32 24 -88 34 -103 18z"/>
<path d="M4820 4899 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6820 4536 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M6825 4450 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7847 3939 c-21 -61 -36 -113 -34 -115 6 -6 79 204 75 216 -2 6 -20
-40 -41 -101z"/>
<path d="M7104 3915 c-3 -8 -1 -29 5 -46 6 -18 12 -44 12 -58 1 -14 5 3 10 38
4 35 6 68 3 73 -8 13 -24 9 -30 -7z"/>
<path d="M7782 3753 c-11 -32 -23 -66 -27 -75 -4 -10 -3 -18 2 -18 10 0 57
139 50 146 -3 3 -14 -21 -25 -53z"/>
<path d="M7120 3689 c0 -16 4 -28 9 -25 8 5 3 56 -5 56 -2 0 -4 -14 -4 -31z"/>
<path d="M7864 3684 c3 -9 6 -18 6 -20 0 -2 7 -4 15 -4 18 0 19 12 3 28 -17
17 -31 15 -24 -4z"/>
<path d="M2815 3680 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
</g>
</svg>
    )
    }
export default SplatterFive;